/**
 * AI 生文- 修改会话名称
 * @returns
 */
import {
  Flex,
  Button,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormErrorMessage,
  Textarea,
} from "@chakra-ui/react";
import { Field, Form, Formik, FormikErrors } from "formik";
import { ChatTopic } from "@/types/writing";
import { useAppDispatch } from "@/store/hooks";
import { updateChat } from "@/services/api/thunks/chat";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  editInfo: ChatTopic;
};

const EditModal = (props: Props) => {
  const { isOpen, onClose, editInfo } = props;
  const dispatch = useAppDispatch();

  const handleValidate1 = (values: { title: string, role: string }) => {
    const errors: FormikErrors<{ title: string, role: string }> = {};
    if (!values.title) {
      errors.title = "会话名称不能为空";
    }
    // if (!values.role) {
    //   errors.role = "角色设定不能为空";
    // }
    return errors;
  };

  const handleEditSubmit = (values: ChatTopic) => {
    dispatch(updateChat(values))
    onClose();
  };

  const handleCloseEdit = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w="420px" bg="#fff">
        <ModalHeader color="#27314D" fontSize={"18px"}>
          修改名称
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody pb={6}>
          <Formik
            initialValues={editInfo}
            onSubmit={handleEditSubmit}
            validate={handleValidate1}
          >
            <Form>
              <Field name="title">
                {({ field, form }: any) => (
                  <FormControl
                    // mt={"20px"}
                    isInvalid={
                      form.errors.title && form.touched.title
                    }
                  >
                    <Input
                      {...field}
                      h="46px"
                      // bg="rgba(0, 0, 0, 0.3)"
                      color="#27314D"
                      fontSize={"14px"}
                      // border="none"
                      placeholder="会话名称"
                    // borderRadius={0}
                    />
                    <FormErrorMessage>
                      {form.errors.title}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
              <Field name="role">
                {({ field, form }: any) => (
                  <FormControl
                    mt={"20px"}
                    isInvalid={
                      form.errors.role && form.touched.role
                    }
                  >
                    <Textarea
                      {...field}
                      h="46px"
                      // bg="rgba(0, 0, 0, 0.3)"
                      color="#27314D"
                      fontSize={"14px"}
                      // border="none"
                      placeholder="角色设定"
                    // borderRadius={0}
                    />
                    <FormErrorMessage>
                      {form.errors.role}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>

              <Flex mt="40px" justifyContent={"flex-end"}>
                <Button
                  w="76px"
                  h="37px"
                  mr="15px"
                  bg="#CBD1DF"
                  color={"#27314D"}
                  fontSize="12px"
                  fontWeight={"normal"}
                  borderRadius={0}
                  _hover={{
                    bg: "#CBD1DF",
                    color: "#8E94A9",
                  }}
                  onClick={handleCloseEdit}
                >
                  取消
                </Button>
                <Button
                  w="76px"
                  h="37px"
                  bg="#496AE1"
                  color={"#FFFFFF"}
                  fontSize="12px"
                  fontWeight={"normal"}
                  borderRadius={0}
                  _hover={{
                    bg: "#3F5BC1",
                    color: "#E6E6E6",
                  }}
                  type="submit"
                >
                  完成
                </Button>
              </Flex>
            </Form>
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EditModal;
